
import { Component, Vue } from 'vue-property-decorator'
import Dashboard from '@/components/dashboard/Dashboard.vue'
import authModule from '@/store/auth'

@Component({
  name: 'Home',
  components: { Dashboard }
})
class Home extends Vue {
  public get auth() {
    return authModule
  }
  public beforeCreate(): void {
    if (authModule.isPartner) {
      this.$router.replace({ name: 'AllDeals' })
    } else if (authModule.isLightPartner) {
      this.$router.replace({ name: 'ScanCode' })
    }
  }
}

export default Home
